import React, { createContext, useContext, useEffect, useState, useRef } from "react";
import {
  formateContentList,
  generateUniqueId,
  getAccuratePixels,
  getTotalDimansion,
  MODULE,
} from "../utils/global";
import { icon_mapping } from "../assets/Icons/iconMapping";

const DraggableContext = createContext();

export const useDraggable = () => {
  return useContext(DraggableContext);
};

export const DraggableProvider = ({ children }) => {
  const [content, setContent] = useState([]);
  const [content2, setContent2] = useState([]);
  const [content3, setContent3] = useState([]);
  const [selectedIcons, setSelectedIcons] = useState({});
  const [logo, setLogo] = useState({
    image: null,
    image2: null,
    image3: null,
  });
  const [currentDragData, setCurrentDragData] = useState(null);
  const [touchStarted, setTouchStarted] = useState(false);
  const dragDataRef = useRef(null);

  const [design, setDesign] = useState({
    frame: "glass",
    color: "black",
    size: "",
    varients: "",
  });

  // const checkOverflow = (input, item, key, isDownloadMode) => {
  //   const container = document.getElementById("main-board");
  //   const { scrollWidth, scrollHeight } = container;
  //   const { width, height } = input;
  //   const { totalWidth, totalHeight } = getTotalDimansion(
  //     getContentFromKeys(key),
  //     isDownloadMode,
  //     design?.size,
  //     item
  //   );

  //   const itemWidth = isDownloadMode
  //     ? item?.data?.width
  //     : getAccuratePixels(item?.data?.width);

  //   let newScrollWidth = totalWidth;
  //   console.log(itemWidth, "item?.data?.width");

  //   const parentWdith = isDownloadMode ? width : getAccuratePixels(width);

  //   const outerPadding = isDownloadMode
  //     ? MODULE[design?.size]?.paddingInline
  //     : getAccuratePixels(MODULE[design?.size]?.paddingInline);
  //   console.log(outerPadding, "outerPadding");

  //   let tempWidth = parentWdith - outerPadding * 2;
  //   // if (design?.size == 6) {
  //   //   tempWidth = tempWidth + width;
  //   //   newScrollWidth = newScrollWidth + 150;
  //   // }
  //   console.log(parentWdith, newScrollWidth, "totalWidth, newScrollWidth");
  //   console.log(parentWdith - newScrollWidth, "totalWidth, newScrollWidth");
  //   console.log(tempWidth, "tempWidth");

  //   if (newScrollWidth > tempWidth) {
  //     alert("Maximum limit reached! Overflow detected.");
  //     return true;
  //   }

  //   return false;
  // };

  const checkOverflow = (input, item, key, isDownloadMode) => {
    let singleItems = ["rj45", "rj11", "usb", "tv_socket"];

    const mapBefore = getContentFromKeys(key);
    const addedMap = [...mapBefore, item?.data];

    let currentnumbers = 0;
    console.log(item?.data);

    if (
      item?.data?.space == 1 &&
      mapBefore[mapBefore?.length - 1]?.space == 0.5 &&
      mapBefore[mapBefore?.length - 2]?.space != 0.5
      //    && (
      //   item?.data?.type != "indian_socket"  && item?.data?.type  != "universal_socket" && item?.data?.type != 'international_socket'
      // )
    ) {
      alert("You can't add 2m after 1m ");
      return true;
    }

    if (design?.frame == "touch_panel_pro" && item?.data?.space == 1) {
      alert(
        "Only (6M) 9 Switches + master and (6M) 6 Switch + Fan + master is allowed"
      );
      return true;
    }

    addedMap?.forEach((item) => {
      // if (singleItems.includes(item?.type)) {
      //   currentnumbers = currentnumbers + 0.5;
      // } else {
      //   currentnumbers = currentnumbers + 1;
      // }
      currentnumbers = currentnumbers + item?.space;
    });

    if (design?.size == 1) {
      if (currentnumbers > 1) {
        alert(
          "The selected item doesn't have enough space to fit, so please select appropriate items."
        );
        return true;
      }
    }

    if (design?.size == 2) {
      if (currentnumbers > 2) {
        alert(
          "The selected item doesn't have enough space to fit, so please select appropriate items."
        );
        return true;
      }
    }

    if (design?.size == 3) {
      if (currentnumbers > 3) {
        alert(
          "The selected item doesn't have enough space to fit, so please select appropriate items."
        );
        return true;
      }
    }

    if (design?.size == 4) {
      if (currentnumbers > 4) {
        alert(
          "The selected item doesn't have enough space to fit, so please select appropriate items."
        );
        return true;
      }
    }

    if (design?.size == 6) {
      if (currentnumbers > 3) {
        alert(
          "The selected item doesn't have enough space to fit, so please select appropriate items."
        );
        return true;
      }
    }

    if (design?.size == 9) {
      if (currentnumbers > 3) {
        alert(
          "The selected item doesn't have enough space to fit, so please select appropriate items."
        );
        return true;
      }
    }

    if (design?.size == 10) {
      if (currentnumbers > 10) {
        alert(
          "The selected item doesn't have enough space to fit, so please select appropriate items."
        );
        return true;
      }
    }

    return false;
  };
  
  const getContentFromKeys = (key) => {
    return content?.find((item) => item.key == key)?.data;
  };

  const setContentFromKeys = (key, data) => {
    let updatedContent = content.map((item) => {
      if (item?.key == key) {
        return {
          ...item,
          data: data,
        };
      }
      return item;
    });

    setContent(updatedContent);
  };

  const deleteContentFromKeys = (key, id) => {
    let contents = getContentFromKeys(key);

    let filteredStates = contents?.filter((item) => item?.uid != id);

    setContentFromKeys(key, filteredStates);
  };

  // Create or update the drag data element in the DOM
  const updateDragDataInDOM = (data) => {
    // Check if the element already exists
    let dragDataElement = document.getElementById('drag-data-element');
    
    if (!dragDataElement) {
      // Create the element if it doesn't exist
      dragDataElement = document.createElement('div');
      dragDataElement.id = 'drag-data-element';
      dragDataElement.style.display = 'none';
      document.body.appendChild(dragDataElement);
    }
    
    // Store the data as a data attribute
    dragDataElement.setAttribute('data-drag-data', JSON.stringify(data));
    dragDataRef.current = data;
  };

  const handleDragStart = (e, data) => {
    const input = {
      ...data,
    };
    
    setCurrentDragData(input);
    updateDragDataInDOM(input);
    e.dataTransfer.setData("data", JSON.stringify(input));
  };

  const handleTouchStart = (e, data) => {
    e.preventDefault();
    const input = {
      ...data,
    };
    
    setCurrentDragData(input);
    updateDragDataInDOM(input);
    setTouchStarted(true);
    
    // Store initial touch position for later calculations
    const touch = e.touches[0];
    const touchTarget = e.target;
    
    // Save initial touch coordinates to track movement
    dragDataRef.current = {
      ...input,
      initialX: touch.clientX,
      initialY: touch.clientY,
      target: touchTarget,
      offsetX: touch.clientX - touchTarget.getBoundingClientRect().left,
      offsetY: touch.clientY - touchTarget.getBoundingClientRect().top
    };
    
    // Add visual feedback for touch drag start
    if (touchTarget) {
      touchTarget.style.opacity = "0.5";
      touchTarget.style.boxShadow = "0 0 10px rgba(0,0,0,0.3)";
    }
  };
  
  const handleTouchMove = (e) => {
    if (!touchStarted || !dragDataRef.current) return;
    
    // Prevent scrolling while dragging
    e.preventDefault();
    
    const touch = e.touches[0];
    
    // Create a visual drag indicator if it doesn't exist
    let dragIndicator = document.getElementById('touch-drag-indicator');
    if (!dragIndicator) {
      dragIndicator = document.createElement('div');
      dragIndicator.id = 'touch-drag-indicator';
      dragIndicator.style.position = 'fixed';
      dragIndicator.style.pointerEvents = 'none';
      dragIndicator.style.zIndex = '9999';
      dragIndicator.style.opacity = '0.7';
      dragIndicator.style.background = '#3498db';
      dragIndicator.style.padding = '10px 20px';
      dragIndicator.style.borderRadius = '4px';
      dragIndicator.style.color = 'white';
      dragIndicator.style.boxShadow = '0 2px 10px rgba(0,0,0,0.2)';
      
      // If we have access to the element being dragged, we can display its label
      dragIndicator.textContent = dragDataRef.current?.label || 'Dragging...';
      
      document.body.appendChild(dragIndicator);
    }
    
    // Position the indicator where the finger is, accounting for the offset
    dragIndicator.style.left = `${touch.clientX - (dragDataRef.current.offsetX || 0)}px`;
    dragIndicator.style.top = `${touch.clientY - (dragDataRef.current.offsetY || 0)}px`;
    
    // Highlight potential drop targets
    const elemBelow = document.elementFromPoint(touch.clientX, touch.clientY);
    const droppableArea = elemBelow?.closest('[data-droppable="true"]');
    
    // Reset all droppable areas
    document.querySelectorAll('[data-droppable="true"]').forEach(area => {
      area.style.backgroundColor = '';
      area.style.transition = 'background-color 0.2s ease';
    });
    
    // Highlight the current droppable area
    if (droppableArea) {
      droppableArea.style.backgroundColor = 'rgba(52, 152, 219, 0.2)';
    }
  };
  
  const handleTouchEnd = (e, params, index, key, isDownloadMode) => {
    if (!touchStarted || !dragDataRef.current) return;
    
    // Remove the drag indicator if it exists
    const dragIndicator = document.getElementById('touch-drag-indicator');
    if (dragIndicator) {
      document.body.removeChild(dragIndicator);
    }
    
    // Reset visual feedback on the original element
    if (dragDataRef.current.target) {
      dragDataRef.current.target.style.opacity = "1";
      dragDataRef.current.target.style.boxShadow = "";
    }
    
    // Reset all highlighted droppable areas
    document.querySelectorAll('[data-droppable="true"]').forEach(area => {
      area.style.backgroundColor = '';
    });
    
    // Get the element under the touch point
    const touch = e.changedTouches[0];
    const elemBelow = document.elementFromPoint(touch.clientX, touch.clientY);
    
    // Check if we're dropping on a droppable area
    const droppableArea = elemBelow?.closest('[data-droppable="true"]');
    
    if (droppableArea) {
      // Extract parameters from the droppable area's data attributes
      const droppableParams = {
        width: droppableArea.dataset.width,
        height: droppableArea.dataset.height,
      };
      
      const droppableIndex = droppableArea.dataset.index !== undefined 
        ? parseInt(droppableArea.dataset.index, 10) 
        : undefined;
        
      const droppableKey = droppableArea.dataset.key;
      
      // Process the drop with touch event data
      processDrop(
        droppableParams || params,
        dragDataRef.current,
        droppableIndex !== undefined ? droppableIndex : index,
        droppableKey || key,
        isDownloadMode,
        touch
      );
    }
    
    // Reset state
    setTouchStarted(false);
    setCurrentDragData(null);
    dragDataRef.current = null;
  };

  const processDrop = (params, item, index, key, isDownloadMode, eventPoint = null) => {
    // check overflow
    if (checkOverflow(params, item, key, isDownloadMode)) {
      return;
    }

    if (design.frame == "glass" && item?.data?.type == "indian_socket") {
      const indianSockts = getContentFromKeys(key)?.filter(
        (item) => item?.type == "indian_socket"
      );

      if (indianSockts?.length >= 1) {
        alert("Only one indian socket allow in glass frame.");
        return;
      }
    }

    // For touch events, we need to use the data directly from dragDataRef
    // because we don't have dataTransfer
    const inputData = item.data || item;
    
    const input = {
      ...inputData,
      uid: generateUniqueId(),
    };

    if (index !== undefined) {
      let newContent = [...getContentFromKeys(key)];
      
      if (eventPoint && 'changedTouches' in eventPoint) {
        // For touch events
        const touch = eventPoint.changedTouches[0];
        const target = document.elementFromPoint(touch.clientX, touch.clientY);
        
        if (target) {
          const rect = target.getBoundingClientRect();
          const middleX = rect.left + rect.width / 2;
          const dropX = touch.clientX;

          if (dropX < middleX) {
            // left side insertion
            newContent.splice(index, 0, input);
          } else {
            // right side insertion
            newContent.splice(index + 1, 0, input);
          }
        } else {
          // Fallback: add to the end
          newContent.push(input);
        }
      } else if (eventPoint) {
        // For mouse events with location information
        const target = document.elementFromPoint(eventPoint.clientX, eventPoint.clientY);
        
        if (target) {
          const rect = target.getBoundingClientRect();
          const middleX = rect.left + rect.width / 2;
          const dropX = eventPoint.clientX;

          if (dropX < middleX) {
            // left
            newContent.splice(index, 0, input);
          } else {
            // right
            newContent.splice(index + 1, 0, input);
          }
        } else {
          // Fallback if we can't determine the element
          newContent.splice(index, 0, input);
        }
      } else {
        // Standard mouse event without position data
        newContent.splice(index, 0, input);
      }

      setContentFromKeys(key, formateContentList(newContent, design));
      return;
    }

    // If no index is provided, add to the end
    setContentFromKeys(
      key,
      formateContentList([...getContentFromKeys(key), input], design)
    );
  };

  const handleDrop = (e, params, index, key, isDownloadMode) => {
    e.preventDefault();
    const itemJson = e.dataTransfer.getData("data"); // Retrieve the dragged data
    const item = JSON.parse(itemJson);

    processDrop(params, item, index, key, isDownloadMode, e);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDeleteElement = (id, key) => {
    deleteContentFromKeys(key, id);
  };

  const handleSetSelectIcon = (data, switchid) => {
    setSelectedIcons((prev) => ({
      ...prev,
      [switchid]: data,
    }));
  };

  const deleteSelectedicon = (switchid) => {
    setSelectedIcons((prev) => {
      const { [switchid]: _, ...rest } = prev;
      return rest;
    });
  };

  /**
   * Auto-assigns number icons to switches based on their position
   * Numbers follow a column-first pattern within each module (top to bottom, then left to right)
   * Each module resets numbering to 1
   * Example for 3 switches:
   * 1 3 5
   * 2 4 6
   */
  const assignDefaultNumberIcons = () => {
    if (!content || content.length === 0) {
      return;
    }

    // Collect all switches with their positions and identifiers
    const switches = [];
    const switchTypes = ["2", "master", "curtain-up", "curtain-down", "fan", "fan-volume-up", "fan-volume-down"];

    // Iterate through content (each contentItem represents a row/line)
    content.forEach((contentItem, contentIndex) => {
      // Iterate through modules in this row (horizontal order)
      contentItem.data?.forEach((module, moduleIndex) => {
        if (module.accessory) {
          module.accessory.forEach((accessory) => {
            accessory.list?.forEach((switchItem) => {
              // Only include switch types (exclude fan-dot, moduler_dot, etc.)
              if (switchTypes.includes(switchItem.type)) {
                // Get position values
                let topPos = switchItem.top;
                let leftPos = switchItem.left;
                let bottomPos = switchItem.bottom;
                let rightPos = switchItem.right;

                // Calculate effective positions for sorting
                // If top is undefined but bottom exists, we need to approximate
                // Since we don't have module height, we'll use a large number minus bottom
                // Lower bottom = higher top position
                const effectiveTop = topPos !== undefined 
                  ? topPos 
                  : (bottomPos !== undefined ? 10000 - bottomPos : 0);

                // If left is undefined but right exists, approximate
                // Lower right = more to the left
                const effectiveLeft = leftPos !== undefined 
                  ? leftPos 
                  : (rightPos !== undefined ? 10000 - rightPos : 0);

                switches.push({
                  uid: module.uid,
                  id: switchItem.id,
                  type: switchItem.type,
                  contentIndex, // Row index (vertical position)
                  moduleIndex,  // Module index in row (horizontal position)
                  top: effectiveTop,
                  left: effectiveLeft,
                  originalTop: topPos,
                  originalLeft: leftPos,
                  originalBottom: bottomPos,
                  originalRight: rightPos,
                  key: contentItem.key,
                });
              }
            });
          });
        }
      });
    });

    if (switches.length === 0) {
      return;
    }

    // Get number icons from icon mapping
    // For laminate_varient frames, use switchSelected icons; otherwise use switch icons
    const iconType = design?.frame === "laminate_varient" ? "switchSelected" : "switch";
    const numberIconsSection = icon_mapping?.[iconType]?.find(
      (section) => section.name === "Number"
    );

    if (!numberIconsSection || !numberIconsSection.icons) {
      console.error("Number icons not found in icon mapping");
      return;
    }

    // Create updated selectedIcons object
    const updatedIcons = { ...selectedIcons };

    // Group switches by module (contentIndex, moduleIndex)
    const switchesByModule = {};
    switches.forEach((switchItem) => {
      const moduleKey = `${switchItem.contentIndex}-${switchItem.moduleIndex}`;
      if (!switchesByModule[moduleKey]) {
        switchesByModule[moduleKey] = [];
      }
      switchesByModule[moduleKey].push(switchItem);
    });

    // Type to icon mapping for specific switch types
    const typeIconMapping = {
      "master": { id: "masterOnOff-1", section: "Master On Off", type: "master" },
      "curtain-up": { id: "curtainopen-1", section: "Curtain Open", type: "curtainOpen" },
      "curtain-down": { id: "curtainclose-1", section: "Curtain Close", type: "curtainClose" },
      "fan": { id: "fanIcon-2", section: "Fan", type: "fan" },
      "fan-volume-up": { id: "fanplus-14", section: "Fan Plus", type: "fanPlus" },
      "fan-volume-down": { id: "fanminus-14", section: "Fan Minus", type: "fanMinus" },
    };

    // Process each module and assign icons
    Object.keys(switchesByModule).forEach((moduleKey) => {
      const moduleSwitches = switchesByModule[moduleKey];
      
      // Sort switches within module: first by left (columns), then by top (rows)
      moduleSwitches.sort((a, b) => {
        // First, sort by left position (column-first)
        if (a.left !== b.left) {
          return a.left - b.left;
        }
        
        // Then, sort by top position (top to bottom within column)
        return a.top - b.top;
      });

      // Assign icons based on type
      let numberIconIndex = 1; // Counter for type "2" numbering
      moduleSwitches.forEach((switchItem) => {
        const switchId = `${switchItem.uid}//${switchItem.id}`;
        let iconToAssign = null;

        if (switchItem.type === "2") {
          // For type "2", use number icons
          const numberIcon = numberIconsSection.icons[numberIconIndex];
          if (numberIcon) {
            iconToAssign = {
              id: numberIcon.id,
              section: numberIcon.section,
              type: numberIcon.type,
            };
          }
          numberIconIndex++;
        } else {
          // For other types, use the fixed type mapping
          const typeIcon = typeIconMapping[switchItem.type];
          if (typeIcon) {
            iconToAssign = {
              id: typeIcon.id,
              section: typeIcon.section,
              type: typeIcon.type,
            };
          }
        }

        if (iconToAssign) {
          updatedIcons[switchId] = iconToAssign;
        }
      });
    });

    // Update the selectedIcons state
    setSelectedIcons(updatedIcons);
  };
  
  const value = {
    content,
    design,
    content2,
    content3,
    setContent2,
    setContent3,
    setDesign,
    setContent,
    handleDragStart,
    handleDrop,
    handleDragOver,
    handleDeleteElement,
    selectedIcons,
    handleSetSelectIcon,
    deleteSelectedicon,
    setSelectedIcons,
    logo,
    setLogo,
    // Add touch event handlers to the context
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
    touchStarted,
    dragDataRef,
    assignDefaultNumberIcons,
  };

  return (
    <DraggableContext.Provider value={value}>
      {children}
    </DraggableContext.Provider>
  );
};
